import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function LoginPage() {
  const { configured, isAuthenticated, signIn, authLoading } = useAuth();
  const [error, setError] = React.useState('');
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const fromPath = location.state?.from?.pathname || '/';

  const handleSignIn = async () => {
    setError('');
    try {
      await signIn(fromPath);
    } catch (err) {
      setError(err?.message || 'Unable to start sign-in.');
    }
  };

  return (
    <div className="card" style={{ maxWidth: '520px', margin: '2rem auto' }}>
      <h2 className="card-title mb-4">Sign In</h2>

      {!configured && (
        <div className="badge badge-error mb-4">
          Cognito is not configured. Set `VITE_COGNITO_DOMAIN` and `VITE_COGNITO_CLIENT_ID`.
        </div>
      )}

      {error && (
        <div className="badge badge-error mb-4">{error}</div>
      )}

      <p className="text-muted mb-4">
        Authenticate with Cognito to access client files and processing workflows.
      </p>

      <button
        className="btn btn-primary"
        type="button"
        onClick={handleSignIn}
        disabled={!configured || authLoading}
      >
        {authLoading ? 'Signing in...' : 'Continue to Secure Login'}
      </button>
    </div>
  );
}

export default LoginPage;
